import { render, staticRenderFns } from "./CategoryImport.vue?vue&type=template&id=284b7adb&scoped=true&"
import script from "./CategoryImport.vue?vue&type=script&lang=js&"
export * from "./CategoryImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284b7adb",
  null
  
)

export default component.exports